import { createSelector } from '@td/utils';
import moment from 'moment-timezone';

import ProviderSurgeIncentiveStatus from '../../enums/provider-surge-incentive-status';
import { isDateBefore } from '../../utilities/validations/validations';

const getSurgeIncentiveFromProps = (_, props) => props.surgeIncentive;

export default () =>
  createSelector(
    getSurgeIncentiveFromProps,
    surgeIncentive => {
      const startDate = moment(surgeIncentive.start_date);
      const endDate = moment(surgeIncentive.end_date);

      const currentDate = moment();

      if (
        currentDate.isBetween(
          startDate.clone().subtract(1, 'second'),
          endDate.clone().subtract(1, 'second')
        )
      ) {
        return ProviderSurgeIncentiveStatus.ACTIVE;
      }

      if (isDateBefore(endDate, currentDate)) {
        return ProviderSurgeIncentiveStatus.FINISHED;
      }

      return ProviderSurgeIncentiveStatus.UPCOMING;
    }
  );
